module.exports = __webpack_public_path__ + "img/logo_chememan.9c1ede98.svg";